import React, { useRef } from 'react';
import { Box, css, genesisStyled } from '@leagueplatform/genesis-commons';

// eslint-disable-next-line no-restricted-imports
import { Transition } from 'react-transition-group';
import type { TransitionStatus } from 'react-transition-group/Transition';
import { TransitionProps } from '#types/transition-props.type.ts';

const Element = genesisStyled(Box)(({ stylesProp }) =>
  css({
    ...stylesProp,
  }),
);

export const SlideInHorizontal = ({
  isActive,
  stylesProp,
  duration,
  distance = '-100%',
  children = null,
}: TransitionProps) => {
  const transitionStyles: Record<TransitionStatus, React.CSSProperties> = {
    entering: { transform: `translateX(0)` },
    entered: { transform: `translateX(0)` },
    exiting: { transform: `translateX(0)` },
    exited: {
      transform: `translateX(calc(${distance} * (1 - 2 * var(--league-is-rtl))))`,
    },
    unmounted: {},
  };

  const ref = useRef<HTMLDivElement>(null);
  return (
    <Transition in={isActive} timeout={duration} nodeRef={ref}>
      {(state: TransitionStatus) => (
        <Element
          ref={ref}
          stylesProp={{
            ...stylesProp,
            transition: `transform ${duration}ms ease-in-out`,
          }}
          style={{ ...transitionStyles[state] }}
        >
          {children && children}
        </Element>
      )}
    </Transition>
  );
};
